"use client";

import Image from "next/image";

interface CategoryCardProps {
  title: string;
  image: string;
  onClick: () => void;
  className?: string;
  sizes?: string;
}

export default function CategoryCard({
  title,
  image,
  onClick,
  className = "group relative w-full max-w-90 h-[423.53px] rounded-2xl overflow-hidden mx-auto shadow-lg",
  sizes = "(max-width: 640px) 100vw, (max-width: 1024px) 50vw, 360px",
}: Readonly<CategoryCardProps>) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={className}
    >
      <Image
        src={image}
        alt={title}
        fill
        sizes={sizes}
        className="object-cover transition-transform duration-500 group-hover:scale-105"
      />
      <div className="absolute inset-0 bg-linear-to-t from-black/80 via-black/20 to-transparent" />

      <div className="absolute bottom-6 right-6 left-6 text-white text-xl font-bold text-right">
        {title}
      </div>

      <div className="absolute inset-0 bg-black/40 opacity-0 group-hover:opacity-100 transition-opacity flex items-center justify-center backdrop-blur-sm">
        <span className="px-8 py-3 bg-yellow-400 cursor-pointer text-black rounded-full font-bold text-sm transition-all hover:bg-yellow-500">
          مشاهده آگهی‌ها
        </span>
      </div>
    </button>
  );
}
